module.exports = __webpack_public_path__ + "static/media/PianoSample.afa58736.mp3";